<div class="car-detail__header-right">
  <div class="car-detail__header-right-prices">
    @if (price) {
      <div class="car-detail__header-right-prices-main">
        <h2 class="car-detail__header-right-prices-title">{{ price.cash | price }}</h2>
        @if (price.cashWithoutVAT && price.cashWithoutVAT !== price.cash && price.isVATDeduct) {
          <span>{{ price.cashWithoutVAT | price }} {{ 'globals.withoutVAT' | translate }}</span>
        } @else {
          <span>{{ 'globals.VATDeductionNotAvailable' | translate }}</span>
        }
      </div>
      @if (monthlyPayment) {
        <app-underline-link [color]="'primary'" [active]="true" [app-scrollto]="'financing-calculator'">{{ 'globals.monthlyPayment' | translate }} {{ 'globals.from' | translate | lowercase }} {{ monthlyPayment | price }}</app-underline-link>
      }
    }
  </div>
  <div class="car-detail__header-right-buttons">
    <ng-content></ng-content>
  </div>
  <div class="car-detail__header-right-stickers">
    @if (inStock) {
      @if (branchId === undefined || branchId === 356) {
        <app-sticker [color]="'primary'">{{ 'globals.inStock' | translate }}</app-sticker>
      } @else {
        <app-sticker [color]="'primary'">{{ 'globals.delivery24hours' | translate }}</app-sticker>
      }
    } @else {
      <app-sticker>{{ 'globals.comingSoon' | translate }}</app-sticker>
    }
  </div>
</div>
